<span style="display: flex; align-items: center;">
  <button mat-icon-button (click)="toogleTheme()" matTooltip="Claro/oscuro">
    <mat-icon>@if(themeService.themeSignal().includes("dark")){dark_mode}@else{light_mode}</mat-icon>
  </button>
  <button mat-icon-button [matMenuTriggerFor]="mnColor" aria-label="Colores" matTooltip="Color acento">
    <mat-icon>colorize</mat-icon>
  </button>
  <!--  
$yellow-palette
$blue-palette
$red-palette

$orange-palette
$cyan-palette
$violet-palette


$green-palette
$magenta-palette
-->

  <mat-menu #mnColor="matMenu" style="width: 200px;">
    <button mat-menu-item (click)="setColor('blue')" matTooltip="Reestablecer color" matTooltipPosition="right">
      <span>Reestablecer</span>
    </button>
    <div mat-divider></div>
    <div class="colores">
      <button mat-icon-button (click)="setColor('blue')" style="color: rgb(54, 102, 175);">
        <mat-icon>circle</mat-icon>
      </button>
      <button mat-icon-button (click)="setColor('orange')" style="color: orange;">
        <mat-icon>circle</mat-icon>
      </button>
      <button mat-icon-button (click)="setColor('green')" style="color: green;">
        <mat-icon>circle</mat-icon>
      </button>
      <br>
      <button mat-icon-button (click)="setColor('cyan')" style="color: rgb(89, 218, 218);">
        <mat-icon>circle</mat-icon>
      </button>
      <button mat-icon-button (click)="setColor('violet')" style="color: #d5baff;">
        <mat-icon>circle</mat-icon>
      </button>
      <button mat-icon-button (click)="setColor('magenta')" style="color: #ffabf3;">
        <mat-icon>circle</mat-icon>
      </button>
    </div>




  </mat-menu>
  <mat-divider></mat-divider>
  &nbsp;
  @if(isMobile){
  <button mat-icon-button [matMenuTriggerFor]="mnUsuario" aria-label="Opciones del usuario">
    <mat-icon>
      <img class="avatar" [src]="miniaturePath" alt="miniature">
    </mat-icon>
  </button>
  }@else{
  <button mat-stroked-button [matMenuTriggerFor]="mnUsuario" aria-label="Opciones del usuario"
    style="padding: 1px;padding-right: 12px;padding-left: 9px;">
    <mat-icon style="height: 100%;width: 32px;">
      <img class="avatar" [src]="miniaturePath" alt="miniature">
    </mat-icon>
    <span style="font-size: smaller;">
      {{ username}}
    </span>
  </button>
  }
  <mat-menu #mnUsuario="matMenu">
    @if(isMobile){
    <button mat-menu-item (click)="toogleTheme()">
      <mat-icon>@if(themeService.themeSignal().includes("dark")){dark_mode}@else{light_mode}</mat-icon>
      <span>Cambiar Tema</span>
    </button>
    <mat-divider></mat-divider>
    }
    <button mat-menu-item routerLink="administracion/datos-personales">
      <mat-icon>badge</mat-icon>
      <span>Datos personales</span>
    </button>
    <button mat-menu-item routerLink="administracion/cambio-contrasena">
      <mat-icon>password</mat-icon>
      <span>Contrase&ntilde;a</span>
    </button>

      <button mat-menu-item (click)="openPruebas()">
        <mat-icon><span class="material-symbols-outlined">
experiment
</span></mat-icon>
        <span>Pruebas</span>
      </button>

    <button mat-menu-item routerLink="/administracion/firma-electronica">
      <mat-icon><span class="material-symbols-outlined">
          signature
        </span></mat-icon>
      <span>Firma Electr&oacute;nica</span>
    </button>
    <button mat-menu-item routerLink="/administracion/buzon">
      <mat-icon><span class="material-symbols-outlined">
          markunread_mailbox
        </span></mat-icon>
      <span>Buz&oacute;n</span>
    </button>
    @if (!hasAdminRole) {
    <button mat-menu-item routerLink="administracion/lista-envio">
      <mat-icon>format_list_bulleted</mat-icon>
      <span>Lista de env&iacute;o</span>
    </button>
    }
    @if (hasAdminRole) {
    <mat-divider></mat-divider>
    <button mat-menu-item routerLink="/administracion">
      <mat-icon><span class="material-symbols-outlined">settings</span></mat-icon>
      <span>Configuraci&oacute;n</span>
    </button>
    }
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Cerrar sesi&oacute;n</span>
    </button>
  </mat-menu>
</span>